// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mU8M","colBig":"styles_colBig__3-GHW","colSmall":"styles_colSmall__Avr01","shopifyNameWrapper":"styles_shopifyNameWrapper__3ZWyP"};